import { darken, transparentize } from 'polished';
import Status from '../types/enum/Status';
import colors from './colors';

const getShadow = (level: number, status: Status = Status.default) => {
  const y = level;
  const blur = level * 2;
  // FIXME: apply status to create colored shadow

  let color = '#000';
  if (status !== Status.default) {
    color = colors[status.toString()];
  }

  return `0px ${y}px ${blur}px ${transparentize(0.9, darken(0.1, color))}`;
  // return `0px ${y}px ${blur}px rgba(0, 0, 0, 0.15)`;
};

export default getShadow;
